import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-drop-area',
  templateUrl: './drop-area.component.html',
  styleUrls: ['./drop-area.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropAreaComponent {
  @Input() data: [];
  @Input() title: string;
  @Input() connectedTo: any[];
}
